import { render, staticRenderFns } from "./EditPageSabreRemarkContract.vue?vue&type=template&id=26e6acae"
import script from "./EditPageSabreRemarkContract.vue?vue&type=script&lang=js"
export * from "./EditPageSabreRemarkContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports